module.exports = __webpack_public_path__ + "static/media/portrait.adfa5a82.jpg";